/* eslint-disable global-require */
import React from 'react';
import ReactDom from 'react-dom';
import _ from 'lodash';
import styles from './css/GalleryTeaser.styl';
import {GalleryIcon, GalleryAddIcon} from '../../../../shared/Svgs';
import {getGATags} from '../../../../shared/utilities/GAHelpers';
import {
  bindMethods,
  setRef,
} from '../../../../shared/utilities/componentHelpers';

export default class GalleryTeaser extends React.Component {
  static propTypes = {
    allowGallery: React.PropTypes.bool,
    count: React.PropTypes.number,
    isSingleColumn: React.PropTypes.bool,
    items: React.PropTypes.array,
    openCondolenceEntry: React.PropTypes.func,
    showGalleryHandler: React.PropTypes.func,
  };

  static defaultProps = {
    items: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      imageStyles: {
        height: 'auto',
      },
    };

    this.imgContainer = null;
    this.setRefImgContainer = _.partial(setRef, _, 'imgContainer', this);

    bindMethods(this, ['handleResize']);
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  /**
   * Returns image src
   * @param  {object} item            item object
   * @param  {Boolean} isSingleColumn effects size of image
   * @return {string}                 path to image
   */
  getImageSource(item, isSingleColumn) {
    if (_.get(item, 'photo')) {
      const size = isSingleColumn ? '150' : '97';

      return `${item.photo}x?w=${size}&h=${size}`;
    }
    if (_.get(item, 'video')) {
      return `https://cdn-thumbs.viddler.com/thumbnail_2_${item.video}_v1.jpg`;
    }
    if (_.get(item, 'assetsThumbnail')) {
      return require(`./assets/${item.assetsThumbnail}`);
    }
    return null;
  }

  /**
   * Click handler to post condolence/media
   * @param  {function} handler handler function
   * @return {undefined}        returns nothing
   */
  handleEntryClick(handler) {
    getGATags({
      eventCategory: 'bypage_person',
      eventAction: 'sign_guest_book_media',
      eventLabel: 'onpage',
    });
    handler();
  }

  /**
   * resize handler
   * @return {Undefined} returns nothing
   */
  handleResize() {
    const singleColumnHeight = _.get(
      ReactDom.findDOMNode(this.imgContainer),
      'clientWidth',
      'auto'
    );
    const dualColumnHeight = window.innerWidth >= 1280 ? 97 : 73;
    const newHeight = this.props.isSingleColumn
      ? singleColumnHeight
      : dualColumnHeight;

    if (this.state.imageStyles.height !== newHeight) {
      this.setState({
        imageStyles: {
          height: newHeight,
        },
      });
    }
  }

  /**
   * GalleryTeaser JSX
   * @param {object} props default props object
   * @return {JSX}         rendered component
   */
  render() {
    const {
      allowGallery,
      isSingleColumn,
      items,
      openCondolenceEntry,
      showGalleryHandler,
    } = this.props;
    const outsideMediaCount = _.reduce(
      items.slice(0, 3),
      (total, item) =>
        total + (_.get(item, 'node.isNonCondolenceMedia', false) ? 1 : 0),
      0
    );
    const count = this.props.count + outsideMediaCount;
    const filteredItems = _.map(items, item => ({
      assetsThumbnail: _.get(item, 'node.video.assetsThumbnail'),
      id: _.get(item, 'node.id'),
      photo: _.get(item, 'node.photo.url'),
      video: _.get(item, 'node.video.id'),
    }));

    const countOffset =
      filteredItems.length >= 8
        ? count - filteredItems.length + outsideMediaCount
        : 0;
    const isSuppressed = isSingleColumn && filteredItems.length === 0;

    return _.isFunction(openCondolenceEntry) &&
      _.isFunction(showGalleryHandler) &&
      allowGallery &&
      !isSuppressed ? (
      <aside className={styles.GalleryTeaser}>
        <div className={styles.header}>
          <h2>Gallery</h2>
          {_.size(filteredItems) === 0 ? null : (
            <div
              className={styles.cta}
              onClick={_.partial(this.handleEntryClick, openCondolenceEntry)}
            >
              Add a Photo or Video
            </div>
          )}
        </div>
        <div className={styles.group}>
          {_.size(filteredItems) === 0 ? (
            <div
              className={styles.empty}
              onClick={_.partial(this.handleEntryClick, openCondolenceEntry)}
            >
              <div className={styles.TeaserLeft}>
                <GalleryIcon />
              </div>
              <div className={styles.TeaserRight}>
                <p>
                  <GalleryAddIcon /> Add a Photo or Video
                </p>
              </div>
            </div>
          ) : (
            filteredItems.map((item, index) => (
              <figure
                key={index}
                onClick={_.partial(showGalleryHandler, index)}
                ref={this.setRefImgContainer}
                style={this.state.imageStyles}
              >
                <img src={this.getImageSource(item, isSingleColumn)} />
                {index === filteredItems.length - 1 && countOffset >= 1 ? (
                  <figcaption>
                    <p>{`+${countOffset}`}</p>
                  </figcaption>
                ) : null}
              </figure>
            ))
          )}
        </div>
      </aside>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GalleryTeaser/GalleryTeaser.js